import { Subject } from 'rxjs';

class ModalService {
  currenModal = null;
  overlay;

  modalValue$ = new Subject();

  constructor() {
  }

  openModal(id) {
    if (this.currenModal) {
      this.closeModal();
    }

    this.overlay = document.getElementById('overlay');
    this.currenModal = document.getElementById(id);
    this.currenModal.classList.remove('hidden');
    this.overlay.classList.remove('hidden');

    this.modalValue$ = new Subject();
    return this.modalValue$.asObservable();
  }

  closeModal(value) {
    if (this.currenModal) {
      this.modalValue$.next(value);
      this.modalValue$.complete();

      this.currenModal.classList.add('hidden');
      this.overlay.classList.add('hidden');
      this.currenModal = null;
    }
  }
}

export const modalService = new ModalService();
